import { FC } from "react";

export const ArchiveIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V6.5C3 6.25 3.04167 6.025 3.125 5.825C3.20833 5.625 3.31667 5.43333 3.45 5.25L4.85 3.55C4.98333 3.36667 5.15 3.229 5.35 3.137C5.55 3.04567 5.76667 3 6 3H18C18.2333 3 18.45 3.04567 18.65 3.137C18.85 3.229 19.0167 3.36667 19.15 3.55L20.55 5.25C20.6833 5.43333 20.7917 5.625 20.875 5.825C20.9583 6.025 21 6.25 21 6.5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM5.4 6H18.6L17.75 5H6.25L5.4 6ZM5 19H19V8H5V19ZM12 17.575C12.1333 17.575 12.2583 17.554 12.375 17.512C12.4917 17.4707 12.6 17.4 12.7 17.3L15.3 14.7C15.4833 14.5167 15.575 14.2833 15.575 14C15.575 13.7167 15.4833 13.4833 15.3 13.3C15.1167 13.1167 14.8833 13.025 14.6 13.025C14.3167 13.025 14.0833 13.1167 13.9 13.3L13 14.2V11C13 10.7167 12.9043 10.479 12.713 10.287C12.521 10.0957 12.2833 10 12 10C11.7167 10 11.4793 10.0957 11.288 10.287C11.096 10.479 11 10.7167 11 11V14.2L10.1 13.3C9.91667 13.1167 9.68333 13.025 9.4 13.025C9.11667 13.025 8.88333 13.1167 8.7 13.3C8.51667 13.4833 8.425 13.7167 8.425 14C8.425 14.2833 8.51667 14.5167 8.7 14.7L11.3 17.3C11.4 17.4 11.5083 17.4707 11.625 17.512C11.7417 17.554 11.8667 17.575 12 17.575Z"
      fill="currentColor"
    />
  </svg>
);
